/**
 * Shopify Cart Tracking Script
 *
 * Tracks cart adds and injects conversation ID for purchase attribution.
 * Purchases tracked via Shopify webhook (checkout pages are sandboxed).
 *
 * Installation: Add to theme.liquid before </body>
 */

(function() {
  const TRACKING_API_URL = 'https://shopify-chatbot-fresh-zeta.vercel.app/api/track-event';

  const urlParams = new URLSearchParams(window.location.search);
  const chatbotConvId = urlParams.get('chatbot_conv_id');
  const chatbotProductId = urlParams.get('chatbot_product_id');
  const chatbotPosition = urlParams.get('chatbot_position');

  if (chatbotConvId) {
    localStorage.setItem('mg_chatbot_conv_id', chatbotConvId);
    localStorage.setItem('mg_chatbot_product_id', chatbotProductId);
    localStorage.setItem('mg_chatbot_position', chatbotPosition);

    console.log('🤖 Chatbot tracking activated:', {
      conversationId: chatbotConvId,
      productId: chatbotProductId,
      position: chatbotPosition
    });
  }

  function trackChatbotEvent(eventType, eventData = {}, productId = null) {
    const convId = localStorage.getItem('mg_chatbot_conv_id') || localStorage.getItem('mg_conversation_id');

    if (!convId) {return;}

    // Extract product_id from eventData or use provided productId parameter
    const finalProductId = productId || eventData.productId || eventData.product_id || null;

    fetch(TRACKING_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        eventType,
        conversationId: convId,
        productId: finalProductId,
        eventData: {
          ...eventData,
          from_chatbot: true,
          tracked_at: new Date().toISOString(),
          page_url: window.location.href
        },
        pageUrl: window.location.href
      })
    }).then(response => {
      if (response.ok) {
        console.log('✅ Chatbot event tracked:', eventType, eventData);
      } else {
        console.error('❌ Failed to track event:', eventType);
      }
    }).catch(error => {
      console.error('❌ Tracking error:', error);
    });
  }

  async function injectNoteAttributes() {
    const convId = localStorage.getItem('mg_chatbot_conv_id') || localStorage.getItem('mg_conversation_id');
    if (!convId) {return;}

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'chatbot_conv_id': convId,
            '_chatbot_source': 'Michel Germain AI'
          }
        })
      });

      console.log('✅ Conversation ID injected into cart attributes');
    } catch (error) {
      console.error('❌ Failed to inject note attributes:', error);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    let lastTrackedVariant = null;
    let lastTrackedTime = 0;

    function shouldTrack(variantId) {
      const now = Date.now();
      if (variantId === lastTrackedVariant && (now - lastTrackedTime) < 2000) {
        return false;
      }
      lastTrackedVariant = variantId;
      lastTrackedTime = now;
      return true;
    }

    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [url, options] = args;

      if (url.includes('/cart/add') && options?.method === 'POST') {
        try {
          const body = JSON.parse(options.body || '{}');
          const variantId = body.id || body.items?.[0]?.id;

          if (variantId && shouldTrack(variantId)) {
            const productId = localStorage.getItem('mg_chatbot_product_id');

            trackChatbotEvent('added_to_cart', {
              variant_id: variantId,
              quantity: body.quantity || 1
            }, productId);

            injectNoteAttributes();
          }
        } catch (e) {
          console.error('Error tracking cart add:', e);
        }
      }

      return originalFetch.apply(this, args);
    };

    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

    addToCartForms.forEach(form => {
      form.addEventListener('submit', function() {
        const productIdInput = form.querySelector('[name="id"]');
        const quantityInput = form.querySelector('[name="quantity"]');

        if (productIdInput) {
          const variantId = productIdInput.value;

          if (shouldTrack(variantId)) {
            const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
            const productId = localStorage.getItem('mg_chatbot_product_id');

            trackChatbotEvent('added_to_cart', {
              variant_id: variantId,
              quantity: quantity
            }, productId);

            setTimeout(injectNoteAttributes, 500);
          }
        }
      });
    });

    if (window.location.pathname.includes('/cart')) {
      injectNoteAttributes();
    }
  });

  console.log('🛒 Michel Germain cart tracking script loaded');
})();